import { FC } from 'react';
import { useAppSelector } from 'redux/hooks';
import { NotificationInfoItem as NotificationInfoItemType } from '@doda/common/src/interfaces/api/notificationInfo';
import { memberInfoSelector } from '@doda/common/src/redux/features/memberInfo';
import { tl } from '@doda/common/src/utils/adobeAnalyticsUtil';
import { Button, Text } from '@doda/io-react/common';
import classNames from 'classnames';
import styles from './index.module.scss';
import { getTagClassName } from './logics/getTagClassName';
import { getTagText } from './logics/getTagText';

/** NotificationRow Props*/
interface Props {
  notification: NotificationInfoItemType;
}

/**
 * お知らせ一覧で使う、お知らせコンポーネント
 */
export const NotificationRow: FC<Props> = ({ notification }) => {
  const {
    category,
    infoType,
    readedFlg: isRead,
    url,
    text,
    entryDate,
  } = notification;
  const tagClassName = getTagClassName(category, infoType);
  const tagText = getTagText(category);

  // カウンセリング予約訴求の場合は別のコンポーネントを返す
  if (infoType === 'counselingAnnouncement') {
    return <GetCounselingAnnouncementRow url={url} />;
  }

  return (
    // TODO: sp同様ユーザークリックの計測パラメータをクエリパラメータに追加する必要があるか調査して、必要なら追加
    <a
      href={url}
      className={classNames(styles.notificationRow__link, {
        [styles['notificationRow__link--read']]: isRead,
      })}
    >
      <div className={styles.notificationRow__metaRow}>
        <div className={classNames(styles.notificationRow__tag, tagClassName)}>
          {tagText}
        </div>
        <div className={styles.notificationRow__entryDate}>{entryDate}</div>
      </div>
      <Text color="blue" className={styles.notificationRow__content}>
        {text}
      </Text>
    </a>
  );
};

/**
 * カウンセリング予約訴求コンポーネントを返す関数
 * @param {string} url - カウンセリング予約ページのURL
 * @returns {JSX.Element} - カウンセリング予約訴求のコンポーネント
 */
const GetCounselingAnnouncementRow: FC<{ url: string }> = ({ url }) => {
  const memberInfo = useAppSelector(memberInfoSelector);
  return (
    <div className={classNames(styles.noticeCounselingCard)}>
      <div className={styles.noticeCounselingCard__textArea}>
        <img
          src="/cmn_web/img/notification/notification_counseling_offer_advisor_photo.svg"
          alt="カウンセリング案内担当"
          className={styles.noticeCounselingCard__img}
        />
        <p>
          カウンセリング案内担当の霜田です。{memberInfo?.lastName}
          さんの転職の悩みをプロに相談しませんか？今すぐ予約可能です
        </p>
      </div>
      <Button
        as="a"
        href={url}
        variant="orange"
        size="S"
        className={styles.noticeCounselingCard__button}
        onClick={() => {
          tl('oshirase_counseling_banner_click', {});
        }}
      >
        キャリアカウンセリングを予約する
      </Button>
    </div>
  );
};
